import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { checkDailyrentPrice } from 'shared/actions/checkDailyrentPrice/actions';
import {
  closeCalendarModal,
  loadAvailability,
  openCalendarModal,
  setError,
} from 'shared/actions/dailyrentBookingCalendar/actions';
import {
  selectDailyrentBookingCalendar,
  selectDailyrentBookingGeneral,
  selectDailyrentBookingGuests,
} from 'shared/selectors/dailyrentBooking';

export function useCalendarLifecycle() {
  const dispatch = useDispatch();
  const { isOpen, initialLoading, dates } = useSelector(selectDailyrentBookingCalendar);
  const { isLoading } = useSelector(selectDailyrentBookingGeneral);
  const { guestsCount } = useSelector(selectDailyrentBookingGuests);

  const isBusy = initialLoading || isLoading;

  const openCalendar = React.useCallback(async () => {
    dispatch(openCalendarModal());
    dispatch(loadAvailability());

    if (dates.from && dates.to) {
      const errorMessage = await dispatch(
        checkDailyrentPrice({ dates: { start: dates.from, end: dates.to }, guestsCount }),
      );

      if (errorMessage) {
        dispatch(setError(errorMessage));
      }
    }
  }, [dispatch, guestsCount, dates.from, dates.to]);

  const closeCalendar = React.useCallback(() => {
    dispatch(setError(''));
    dispatch(closeCalendarModal());
  }, [dispatch]);

  return { openCalendar, closeCalendar, isBusy, isOpen };
}
